
import { useEffect, useState } from "react";
import Navbar from "../component/Navbar";
import DropdownMenu from "../component/DropdownMenu";
import Footer from "../component/Footer";
import PageTransition from "../component/PageTransition";

export default function Detail() {
  // const { id } = useParams();
  const [item, setItem] = useState(null);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500)); // จำลองการรอโหลดข้อมูล
      const storedItem = localStorage.getItem("selectedItem");
      if (storedItem) {
        try {
          const parsedItem = JSON.parse(storedItem);
          setItem(parsedItem);
        } catch (error) {
          console.error("Error parsing item data:", error);
        }
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {!item ? (
        <PageTransition
          showContent={showContent}
          setShowContent={setShowContent}
        >
          <div className="animate-bounce">Loading...</div>
        </PageTransition>
      ) : (
        <>
          <Navbar />
          <DropdownMenu />
          <div className={`max-w-5xl mx-auto px-5 py-10`}>
            <div className="flex flex-col justify-center items-center gap-y-5">
              <img
                src={item.img}
                className="object-cover w-full rounded-lg"
                alt=""
              />
              <div className="w-full border-b flex justify-between items-center">
                <div className=" ">
                  <span className="text-sm text-gray-600">
                    วันที่ {item.date}
                  </span>
                </div>
                <div
                  onClick={() => window.open(item.link, "_blank")}
                  className="w-10 h-10 cursor-pointer hover:scale-105 transition-all duration-300"
                >
                  <img
                    src="https://img.icons8.com/?size=100&id=118497&format=png&color=000000"
                    className="object-cover drop-shadow-sm"
                    alt=""
                  />
                </div>
              </div>

              <div className=" flex flex-col justify-start items-start gap-y-5">
                <span dangerouslySetInnerHTML={{ __html: item.detail }}></span>
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
}
